import "./FAQ.module.css";
import Header from "@/reusable_sections/Header";
import PreFlightBriefingFaq from "./sections/PreFlightBriefingFaq";
import StillInTheDark from "./sections/StillInTheDark";
import Footer from "@/reusable_sections/Footer";
export default function FAQPage() {
  return <div>
      <Header />
      <PreFlightBriefingFaq />
      <StillInTheDark />
      <Footer />
    </div>;
}